module.exports = __webpack_public_path__ + "static/img/abou1_1.40f49e7e.jpg";